<template>
  <main>
    <div class="sentence">
      <img src="./../assets/logo/Grupo 92.svg" width="35%" alt="osfatun" />
    </div>
    <section class="content">
      <h3 class="title mb-5 has-text-centered">
        Bienvenido Prestador
      </h3>
      <h4 class="title mb-5 has-text-centered">
        Inicie sesion con su CUIT y contraseña para ingresar al sistema.
      </h4>

      <b-card class="login-card" header="Iniciar Sesión">
        <div class="card-content ">
          <form @submit.prevent="login">
            <b-field :type="{ 'is-danger': emailError }">
              <b-input
                type="user"
                v-model="email"
                placeholder="CUIT"
                required
              ></b-input>
            </b-field>
            <b-field :type="{ 'is-danger': passwordError }">
              <b-input
                type="password"
                v-model="password"
                minlength="4"
                icon-pack="fas"
                placeholder="Contraseña"
                password-reveal
                required
              ></b-input>
            </b-field>
            <b-field>
              <b-loading
                :is-full-page="isFullPage"
                v-model="loading"
                :can-cancel="true"
              >
                <b-icon
                  pack="fas"
                  icon="sync-alt"
                  size="is-large"
                  custom-class="fa-spin"
                >
                </b-icon>
              </b-loading>
              <b-button
                class="button"
                type="is-info"
                native-type="submit"
                expanded
              >
                INICIAR SESIÓN
              </b-button>
              
            </b-field>
            <a href="https://api.osfatun.com.ar/forgot-password">
          ¿Olvidaste tu contraseña?
        </a>
          </form>
        </div>
      </b-card>

      <Form />
    </section>
    <Footer>
      <p class="m-2">Desarrollado por</p>
      <img src="../assets/logo/logozaro1.svg" alt="zaro" />
    </Footer>
  </main>
</template>

<script>
import axios from "axios";
import { mapMutations } from "vuex";
import { alertSuccess, alertFailed } from "@/helpers";

export default {
  name: "Login",

  data() {
    return {
      isFullPage: true,
      email: "",
      password: "",
      loading: false,
      baseUrl: "https://api.osfatun.com.ar/",
    };
  },
  methods: {
   async login() {
  try {
    this.loading = true;

    const data = new FormData();
    data.append("email", this.email);
    data.append("password", this.password);

    const response = await axios.post(this.baseUrl + "api/auth/login", data);
    
    console.log("Respuesta:", response.data);

    // Guardar el token en Vuex usando la mutación setToken
    this.setToken(response.data.token);
    this.setName(response.data.name);
    this.setIdUser(response.data.id);
    

    this.loading = false;
    alertSuccess("Ingreso Exitoso!");
    this.$router.push("/new_invoice");
  } catch (error) {
    console.log(error);
    this.password = "";
    this.loading = false;
    alertFailed("Email o contraseña inválidos!");
  }
},

    ...mapMutations(["setToken", "setName", "setIdInvoice", "setIdUser"]),
  },
};
</script>

<style>
.login-card {
  max-width: 400px; /* Ajusta el ancho del b-card */
}
</style>
<style scoped>
.sentence {
  background-image: url("./../assets/fondo.png");
  background-size: 100%;
  width: 100%;
  background-repeat: no-repeat;
  max-height: 33vh ;
  padding: 2em;
}
.sentence img {
  padding: 1em;
  width: 220px;
  margin: 0 auto;
  text-align: center;
  display: block;
  
}

.content {
  position: relative;
  background: white;
  max-width: 40%;
  padding: 40px 30px;
  margin: 0 auto;
}
h4.title {
  font-weight: 500;
  font-size: 15px;
  font-style: normal;
}
.second-container {
  max-width: 90%;
  margin: 0 auto;
}
.hr {
  background-color: #eeeeee;
  margin: 50px 0;
}
h3.title {
  font-size: 49px;
  color: #00758f;
  margin-bottom: 6%;
}
footer {
  margin-top: 15em ;
  display: flex;
  justify-content: center;
  margin-bottom: 1px;
}
.button {
  background: rgba(0, 117, 143, 1);
  display: flex;
  justify-content: flex-center;
  font-family: Gotham Rounded;
  font-size: 14px;
}
.card-content :placeholder-shown {
  background: rgb(228, 227, 227);
}

/* @media screen and (max-width: 1007px) {
  .sentence {
    background-image: url("./../assets/fondo.png");
    background-size: 100%;
    width: 100% auto;
    height: 30vh;
    background-repeat: no-repeat;
  }
}
.sentence img {
  width: 10%;
  margin: 0 auto;
  padding-top: 10%;
  text-align: center;
  display: inline-block;
}

.content {
  position: relative;

  background: white;
  max-width: 40%;
  padding: 40px 30px;
  margin: 0 auto;
} */
@media screen and (max-width: 42em) {
  .sentence {
    max-height: 15vh;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
     padding: 3em;
  }
  
.sentence img {
    width: 35%;
    position: relative;
    max-width: 100%;
    max-height: 100%;
    transform: translate(-50%, -50%);
    top: 40%;
    left: 15%;
    display: block;
    padding-bottom: 0;
  }

  .content {
    position: relative;
    background: white;
    max-width: 95%;
    padding: 40px 20px;
    margin: 1em auto;
  }
  h3.title {
    font-size: 20px;
    margin: 0;
  }
  footer {
    margin-top: 12em auto;
  }
}
</style>
